module.exports = __webpack_public_path__ + "img/woman_teacher.ecf13fc4.png";